import { render, staticRenderFns } from "./EditMicroprotocolDialog.vue?vue&type=template&id=146c0f34&scoped=true&"
import script from "./EditMicroprotocolDialog.vue?vue&type=script&lang=js&"
export * from "./EditMicroprotocolDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditMicroprotocolDialog.vue?vue&type=style&index=0&id=146c0f34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c0f34",
  null
  
)

export default component.exports